import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { useSEO } from '../hooks/useSEO';
import SectionIcon from '../components/SectionIcon';
import HeroArt from '../components/HeroArt';
import './FAQ.css';

const QUESTION_ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 14, 12, 13];

export default function FAQ() {
  const { t } = useLang();
  useSEO(t('faq_title'), t('faq_subtitle'));
  const [openIndex, setOpenIndex] = useState(0);

  const items = QUESTION_ORDER.map((n) => ({
    q: t(`faq_q${n}`),
    a: t(`faq_a${n}`),
  }));

  return (
    <div className="faq-page">
      <div className="page-hero">
        <div className="page-hero-bg" />
        <HeroArt name="faq" />
        <div className="container">
          <SectionIcon name="faq" />
          <span className="section-tag">{t('faq_tag')}</span>
          <h1>{t('faq_title')}</h1>
          <p>{t('faq_subtitle')}</p>
        </div>
      </div>

      <div className="container faq-body">
        <div className="faq-accordion">
          {items.map((item, i) => (
            <div key={i} className={`faq-item ${openIndex === i ? 'open' : ''}`}>
              <button className="faq-question" onClick={() => setOpenIndex(openIndex === i ? -1 : i)}>
                <span>{item.q}</span>
                <span className="faq-toggle">{openIndex === i ? '−' : '+'}</span>
              </button>
              {openIndex === i && <div className="faq-answer"><p>{item.a}</p></div>}
            </div>
          ))}
        </div>

        <div className="faq-cta-box">
          <h3>{t('still_not_sure')}</h3>
          <Link to="/#apply" className="btn-primary">{t('get_free')}</Link>
        </div>
      </div>
    </div>
  );
}
